import { defineMessages } from 'react-intl';

const translations = {
  page: {
    title: {
      id: 'pages.fulfilmentLocations.title',
      defaultMessage: 'Fulfilment locations',
      description: 'title of fulfilment locations page',
    },
    create: {
      button: {
        id: 'pages.fulfilmentLocations.create.button',
        defaultMessage: 'Add location',
        description: 'label of the add location button',
      },
    },
    noAddressMessage: {
      id: 'pages.fulfilmentLocations.noAddressMessage',
      defaultMessage: 'No address',
      description: 'No address message of the fulfilment locations page',
    },
    emptyMessage: {
      id: 'pages.fulfilmentLocations.emptyMessage',
      defaultMessage: 'No fulfilment locations',
      description: 'Empty message of the data list on the fulfilment locations page',
    },
  },
  editFulfilmentLocation: {
    title: {
      id: 'pages.fulfilmentLocations.editFulfilmentLocation.title',
      defaultMessage: 'Edit fulfilment location',
      description: 'Title of the edit fulfilment location drawer',
    },
  },
  confirmDelete: {
    title: {
      id: 'pages.fulfilmentLocations.confirmDelete.title',
      defaultMessage: 'Disable fulfilment location',
      description: 'Title of the disable fulfilment location confirm',
    },
    description: {
      id: 'pages.fulfilmentLocations.confirmDelete.description',
      defaultMessage: 'Are you sure you want to disable this ',
      description: 'description of the disable fulfilment location confirm',
    },
    buttons: {
      delete: {
        id: 'actions.delete',
        defaultMessage: 'Delete',
        description: 'label of the delete button',
      },
      cancel: {
        id: 'actions.cancel',
        defaultMessage: 'Cancel',
        description: 'label of the cancel button',
      },
    },
  },
  feedback: {
    fulfilmentLocationUpdated: {
      id: 'pages.fulfilmentLocations.feedback.fulfilmentLocationUpdated',
      defaultMessage: 'Fulfilment location was updated',
      description: 'feedback message when the location was updated',
    },
    fulfilmentLocationNotUpdated: {
      id: 'pages.fulfilmentLocations.feedback.fulfilmentLocationNotUpdated',
      defaultMessage: 'Could not update fulfilment location',
      description: 'feedback message when the location could not be updated',
    },
    fulfilmentLocationDeleted: {
      id: 'pages.fulfilmentLocations.feedback.fulfilmentLocationDeleted',
      defaultMessage: 'Fulfilment location delete',
      description: 'feedback message when the location was delete',
    },
    fulfilmentLocationNotDeleted: {
      id: 'pages.fulfilmentLocations.feedback.fulfilmentLocationNotDeleted',
      defaultMessage: 'Could not delete fulfilment location',
      description: 'feedback message when the location could not be delete',
    },
  },
};

export default defineMessages(translations);
